import * as _ from 'lodash-es';

(function () {
  angular
    .module('specsguardApp')
    .factory('AreaDecoratorFactory', AreaDecoratorFactory);

  AreaDecoratorFactory.$inject = ['Utils', 'filterModuleFactory', '$stateParams'];

  function AreaDecoratorFactory (Utils, filterModuleFactory, $stateParams) {
    const factory: any = {};

    factory.hasSheet = function () {
      return angular.isDefined(this.sheet);
    };

    factory.getSubTotalFNO = function () {
      return _.reduce(this.areas, function (memo, area) {
        if (area.active === true && area.functionality === 1) {
          return memo + (area.quantity * area.surface);
        }
        return memo;
      }, 0);
    };

    factory.getAreaTotalFNO = function () {
      return this.quantity * this.surface;
    };

    factory.getSubTotalBVO = function () {
      return this.getSubTotalFNO() * this.ratio;
    };

    factory.setBasicAreaForArea = (proj, area) => {
      if (area.basicArea && angular.isObject(area.basicArea)) {
        return area.basicArea;
      }

      return proj.basicAreas.find((bArea) => bArea._id === area.basicArea);
    };

    factory.decorateCluster = function (cluster) {
      Utils.decorate(cluster, 'buildingId', $stateParams.building_id);
      Utils.decorate(cluster, 'hasSheet', factory.hasSheet);
      Utils.decorate(cluster, 'getSubTotalFNO', factory.getSubTotalFNO);
      Utils.decorate(cluster, 'getSubTotalBVO', factory.getSubTotalBVO);
    };

    factory.decorateArea = function (area, project, menuStructure) {
      area.basicArea = factory.setBasicAreaForArea(project, area);
      Utils.decorate(area, 'basicAreas', project.basicAreas);
      Utils.decorate(area, 'getAreaTotalFNO', factory.getAreaTotalFNO);
      if (menuStructure) {
        factory.createAreaMenuStructure(menuStructure, area);
      }
    };

    factory.decorateBoth = function (cluster, project, menuStructure) {
      factory.decorateCluster(cluster, project);
      cluster.areas = cluster.areas.filter((area) => area.active);
      cluster.areas.forEach((area) => factory.decorateArea(area, project, menuStructure));
    };

    factory.decorateClustersAndAreas = function (clusters, project, menuStructure) {
      clusters.forEach((cluster) => factory.decorateBoth(cluster, project, menuStructure));
    };

    factory.createAreaMenuStructure = (menuStructure, area) => {
      area.menuStructure = JSON.parse(JSON.stringify(menuStructure)).map((menu) => {
        menu.modules = filterModuleFactory.filterByProjectLevel(menu.modules, area._id, area.basicArea._id);
        return menu;
      });
    };

    return factory;
  }
})();
